import * as React from 'react';

export const loadable = (
  importFunction: () => Promise<{ default: React.ComponentType }>,
  { fallback = null } = { fallback: null },
): React.FC => {
  const LazyComponent = React.lazy(importFunction);

  return (props) => (
    <React.Suspense fallback={fallback}>
      <LazyComponent {...props} />
    </React.Suspense>
  );
};
